<div (cdkDropListDropped)="drop($event)" cdkDropList class="utilContainer mat-elevation-z8" id="utilContainer">
	@for (template of templates; track template) {
		@if (isHidden($index)) {
			@let panel = panels() && panels()[$index];
			@let isMaximized = maximizedPanel()?.type === panel.type;
			@if (!!panel && (!maximizedPanel() || isMaximized)) {
				<div
					class="paneContainer"
					[class.removed]="panel.isHidden || (showUndockedPanels() ? false : panel.undocked)"
					cdkDrag
					[attr.undocked]="panel.undocked"
					[cdkDragBoundary]="draggable() ? '' : '.utilContainer'"
					[id]="panel.id"
					[class.open]="showUndockedPanels() ? panel.isOpen : panel.isOpen && !panel.undocked"
				>
					<div
						class="pane"
						[class.hasActiveContent]="hasActiveContent(panel.type)"
						[class.open]="panel.isOpen"
						[class.active]="panelOptions().activePanel?.id === panel.id"
					>
						<div class="header" matRipple [matRippleDisabled]="!openable() || disableRipple()" (click)="togglePanel(panel)">
							<button
								mat-icon-button
								[@zoomInOnEnter]
								matTooltip="{{ T.SHARED_NEW_PANEL_GO_BACK | translate }}"
								matTooltipClass="accent"
								(click)="iconClicked()"
								class="backButton"
								color="accent"
								[class.shown]="arrowBackActive()"
							>
								<mat-icon fontSet="fas" fontIcon="fa-arrow-left" inline />
							</button>
							<mat-checkbox
								color="primary"
								class="backButton"
								[class.shown]="showSelectAll()"
								(change)="selectAllClicked.emit()"
							/>
							<div class="icon">
								<mat-icon inline [fontSet]="panel.fontSet" [fontIcon]="panel.icon" />
							</div>
							<div class="text">
								<span class="nomargin">{{ panel.type | enumLabel: EnumLabel.ControlPanelHeader }}</span>
							</div>
							@if (showControls()) {
								<div class="controlsContainer" appStopPropagation>
									<mat-menu #appMenu="matMenu" class="matMenuContainer">
										@if (draggable()) {
											<button mat-menu-item (click)="undockPane(panel)">
												<mat-icon fontSet="fas" fontIcon="fa-window-restore" inline />
												<span>{{ T.SHARED_NEW_PANEL_UNDOCK | translate }}</span>
											</button>
										}
										<button
											(click)="togglePanelHidden(panel)"
											[disabled]="!canHidePanel() || isMaximized"
											mat-menu-item
										>
											<mat-icon fontSet="fas" fontIcon="fa-eye" inline />
											<span>{{ T.SHARED_NEW_PANEL_HIDE | translate }}</span>
										</button>
										<ng-container [ngTemplateOutlet]="templatesMatMenuAdditionalOptions._results[$index]" />
									</mat-menu>
									<button
										matIconButton
										[@zoomInOnEnter]
										matTooltipClass="primary"
										matTooltip="{{ T.SHARED_PANEL_MAXIMIZE_TOGGLE_TOOLTIP | translate }}"
										appStopPropagation
										(click)="maximizedPanel.set(isMaximized ? null : panel)"
									>
										<sim-animated-material-icon
											[startIcon]="{fontIcon: 'fa-expand', fontSet: 'fas'}"
											[endIcon]="{fontIcon: 'fa-compress', fontSet: 'fas'}"
											[trigger]="!!maximizedPanel()"
										/>
									</button>
									@if (showEditMenu()) {
										<button
											appStopPropagation
											mat-icon-button
											[@zoomInOnEnter]
											[matMenuTriggerFor]="appMenu"
											matTooltipClass="primary"
											matTooltip="{{ T.SHARED_NEW_PANEL_OPEN_MENU | translate }}"
										>
											<mat-icon fontSet="fas" fontIcon="fa-ellipsis-v" inline />
										</button>
									}
									@if (openable() && !isMaximized) {
										<button
											mat-icon-button
											[@zoomInOnEnter]
											class="toggleExpand"
											(click)="togglePanel(panel)"
											appStopPropagation
											matTooltip="{{ T.SHARED_NEW_PANEL_EXPAND_COLLAPSE_PANE | translate }}"
											matTooltipClass="primary"
										>
											<mat-icon fontSet="fas" fontIcon="fa-chevron-down" inline />
										</button>
									}
									@if (headerWrapper?.children?.length > 0 && (openable() || draggable() || showEditMenu())) {
										<mat-divider
											[attr.childNodes]="headerWrapper?.children?.length"
											[vertical]="true"
											class="verticalHeaderSeparator"
										/>
									}
									<div #headerWrapper class="additionalHeaderContent">
										<ng-container [ngTemplateOutlet]="templatesHeader._results[$index]" />
									</div>
								</div>
							}
							@if (isDragAndDrop() && !isMaximized) {
								<button
									[@zoomInOnEnter]
									[disableRipple]="true"
									class="gripHandleBtn"
									mat-icon-button
									cdkDragHandle
									matTooltip="{{ T.DRAG_AND_DROP | translate }}"
									(mouseover)="disableRipple.set(true)"
									(mouseout)="disableRipple.set(false)"
									appStopPropagation
									matTooltipClass="primary"
								>
									@if (draggable()) {
										<mat-icon fontIcon=" fa-arrows-up-down-left-right" fontSet="fas" inline />
									} @else {
										<mat-icon fontIcon="fa-arrows-v" fontSet="fas" inline />
									}
								</button>
							}
						</div>
						<div class="content">
							<ng-container [ngTemplateOutlet]="template" />
						</div>
					</div>
				</div>
			}
		}
	}
</div>
